import { createFileRoute } from "@tanstack/react-router";
import ResourceManager from "@/features/inventory/ResourceManager";
import { RequireCapability } from "@/components/require-capability";

export const Route = createFileRoute("/settings/inventory/resources")({
  component: () => (
    <RequireCapability cap="inventory:manage">
      <SettingsResourcesPage />
    </RequireCapability>
  ),
});

function SettingsResourcesPage() {
  return (
    <div className="container mx-auto px-4 py-6 flex flex-col grow min-h-0 gap-4">
      <div>
        <h1 className="text-lg font-semibold">Resources</h1>
        <p className="text-sm text-muted-foreground">
          Manage resource types used in inventory tracking.
        </p>
      </div>
      <ResourceManager onClose={() => {}} />
    </div>
  );
}
